import CssBaseline from '@mui/material/CssBaseline';
import * as PropTypes from 'prop-types';
import Configurator from 'components/Configurator';
import DigiAiRoutes from 'pages/DigiAiRoutes';

export function MainLayout({ layout, routes, configsButton }) {
  return (
    <>
      <CssBaseline />
      {layout === 'dashboard' && (
        <>
          <Configurator />
          {configsButton}
        </>
      )}
      <DigiAiRoutes routes={routes} />
    </>
  );
}

MainLayout.propTypes = {
  layout: PropTypes.any,
  routes: PropTypes.any,
  configsButton: PropTypes.any
};
